// scroll-academic — Bitiruv graduation card (g01).
//
// Reads as a sealed diploma: outer paper has a navy + crimson dual-edge
// trim, inner cream page holds a round photo medallion in the centre,
// crowned by a mortar-board ornament. "BITIRUV" eyebrow in roman small-
// caps. Cormorant SC names. Small-cap date + venue caption.
import { Photo, type LayoutCtx } from "./_shared";

export function ScrollAcademicLayout({
  names,
  date,
  venue,
  accent,
  ink,
  bg,
  font,
  photo,
}: LayoutCtx) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `linear-gradient(180deg, ${ink} 0%, ${ink} 4%, ${accent} 4%, ${accent} 6%, ${bg} 6%, ${bg} 94%, ${accent} 94%, ${accent} 96%, ${ink} 96%, ${ink} 100%)`,
        padding: "5%",
        display: "flex",
      }}
    >
      <div
        style={{
          flex: 1,
          background: bg,
          color: ink,
          position: "relative",
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          boxShadow: `inset 0 0 0 1px ${ink}33, inset 0 0 0 5px ${bg}, inset 0 0 0 6px ${accent}55`,
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 7,
            fontWeight: 700,
            letterSpacing: "0.4em",
            color: accent,
            marginBottom: "5%",
          }}
        >
          BITIRUV
        </div>

        {/* Mortar-board ornament above the medallion */}
        <svg viewBox="0 0 60 30" style={{ width: "22%", marginBottom: "2%" }} aria-hidden>
          <path d="M30 4 L52 14 L30 24 L8 14 Z" fill={ink} opacity="0.9" />
          <path d="M16 18 L16 26 Q 30 30 44 26 L 44 18" fill="none" stroke={ink} strokeWidth="1.4" opacity="0.85" />
          <line x1="52" y1="14" x2="55" y2="22" stroke={accent} strokeWidth="1.4" />
          <circle cx="55" cy="23" r="2" fill={accent} />
        </svg>

        {/* Photo medallion */}
        <div
          style={{
            width: "55%",
            aspectRatio: "1 / 1",
            position: "relative",
            marginBottom: "5%",
            borderRadius: "50%",
            overflow: "hidden",
            boxShadow: `0 0 0 3px ${bg}, 0 0 0 4px ${ink}55, 0 0 0 6px ${bg}, 0 0 0 7px ${accent}66`,
          }}
        >
          <Photo
            src={photo}
            style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}
            fallback={
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background: `radial-gradient(circle at 50% 40%, ${ink}33, ${bg})`,
                }}
              />
            }
          />
        </div>

        <div style={{ fontFamily: font, fontSize: 28, lineHeight: 1.1, fontWeight: 500, color: ink, letterSpacing: "0.04em" }}>
          {names}
        </div>

        <div style={{ flex: 1 }} />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 700,
            letterSpacing: "0.32em",
            color: accent,
            marginTop: "4%",
          }}
        >
          BITIRUV · {date.toUpperCase()}
        </div>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6,
            fontWeight: 600,
            letterSpacing: "0.28em",
            color: `${ink}99`,
            marginTop: 6,
          }}
        >
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
